import { LoadingIndicator } from '@bambi/component-library/src/components/LoadingIndicator/LoadingIndicator';

import {
  TripListRead,
  TripRead,
  useTripsPriceSummaryRetrieveQuery,
} from 'src/common/external/bambi-api/bambiApi';
import { NoPriceSummaryFoundContent } from 'src/common/pricing/NoPriceSummaryFoundContent/NoPriceSummaryFoundContent';

import { PriceSummaryTable } from './PriceSummaryTable/PriceSummaryTable';

export function PriceSummaryModalContent({
  selectedTrip,
}: {
  selectedTrip: TripRead | TripListRead | null;
}) {
  const { data, isLoading, isFetching, error } =
    useTripsPriceSummaryRetrieveQuery(
      { id: selectedTrip?.id || '' },
      { skip: !selectedTrip?.id }
    );

  if (isLoading || isFetching) {
    return (
      <div className="flex min-h-[300px] items-center justify-center text-lg">
        <LoadingIndicator />
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex min-h-[300px] items-center justify-center text-lg">
        There was an error fetching the price summary.
      </div>
    );
  }

  if (data?.price_summary) {
    return <PriceSummaryTable summary={data.price_summary} />;
  }

  if (!selectedTrip) {
    return (
      <div className="flex min-h-[300px] items-center justify-center text-lg">
        No Price Summary Available for this Trip.
      </div>
    );
  }

  return (
    <NoPriceSummaryFoundContent
      payerId={selectedTrip.payer.id || ''}
      payerName={selectedTrip.payer.display_name}
      dateOfTrip={selectedTrip.scheduled_pickup_at}
      spaceType={selectedTrip.space_type}
      serviceType={selectedTrip.service_type}
    />
  );
}
